import { ParsedCommand } from './commandParser';

export interface VoiceContextState {
  currentWellId?: string;
  currentPage?: string;
  lastCommands: ParsedCommand[];
}

let contextState: VoiceContextState = {
  currentWellId: undefined,
  currentPage: undefined,
  lastCommands: [],
};

export function updateVoiceContext(partial: Partial<VoiceContextState>) {
  contextState = {
    ...contextState,
    ...partial,
    lastCommands: partial.lastCommands ?? contextState.lastCommands,
  };
}

export function getVoiceContext(): VoiceContextState {
  return contextState;
}

export function registerCommandInContext(command: ParsedCommand) {
  const nextHistory = [...contextState.lastCommands, command].slice(-10);
  contextState = {
    ...contextState,
    lastCommands: nextHistory,
  };

  if (command.action === 'go_to_well' && command.parameters.wellId) {
    contextState.currentWellId = command.parameters.wellId;
  }

  if (command.action === 'go_to_page' && command.parameters.page) {
    contextState.currentPage = command.parameters.page;
  }
}
